// Routes
////
// Basic
import Vue from "vue";
import Analytics from "./views/Analytics.vue";
// Public
import Landing from "./views/Landing";
import Terms from "./views/Docs/Terms.vue";
import Privacy from "./views/Docs/Privacy.vue";
import EmailSettings from "@/components/EmailSettings.vue";
import Router from "vue-router";
// Campaigns
import Campaigns from "./views/Campaigns/Campaigns.vue";
import CampaignForm from "./views/Campaigns/CampaignForm.vue";
import CampaignForm2 from "./views/Campaigns/CampaignForm2.vue";
import CampaignCompanies from "./views/Campaigns/CampaignCompanies.vue";
import CampaignProspects from "./views/Campaigns/CampaignProspects.vue";
import TemplateEditor from "./views/Campaigns/TemplateEditor.vue";
import EditUserProfile from "./views/EditUserProfile.vue";
// Authentication
import Login from "./views/Auth/Login.vue";
import Register from "./views/Auth/Register.vue";
import ForgotPassword from "./views/Auth/ForgotPassword.vue";
import ChangePassword from "./views/Auth/ChangePassword.vue";
import Errors from "./views/Errors.vue";
// Billing
import Billing from "./views/Billing/Billing.vue";
import HasCard from "./views/Billing/HasCard.vue";
import Invoices from "./views/Billing/Invoices.vue";
import Plan from "./views/Billing/Plan.vue";
import LinkedInOauthRedirect from "@/components/common/Linkedin/LinkedInOauthRedirect.vue";
import GmailOauthRedirect from "@/components/common/Gmail/GmailOauthRedirect.vue";
import OtherOauthRedirect from "@/components/common/Other/OtherOauthRedirect.vue";
import VerifyEmail from "./views/VerifyEmail.vue";
//
// CURRENTLY UNUSED
import SocialInbox from "./views/SocialInbox.vue";
import Team from "./views/Team.vue";
import Tips from "./views/Tips.vue";
//
//
//
Vue.use(Router);
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: "/dash",
      redirect: "/analytics"
    },
    {
      path: "/",
      name: "landing",
      meta: {
        layout: "landing",
        public: true
      },
      component: Landing
    },
    {
      path: "/tips",
      name: "tips",
      component: Tips,
      meta: {
        public: true
      }
    },
    {
      path: "/social-inbox",
      name: "social-inbox",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: SocialInbox
    },
    {
      path: "/analytics",
      name: "analytics",
      component: Analytics,
      meta: {
        public: false
      }
    },
    {
      path: "/campaigns",
      name: "campaigns",
      component: Campaigns,
      meta: {
        public: false
      }
    },
    {
      path: "/new-campaign",
      name: "new-campaign",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: CampaignForm
    },
    {
      path: "/new-campaign-2",
      name: "new-campaign-2",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: CampaignForm2
    },
    {
      path: "/team",
      name: "team",
      component: Team,
      meta: {
        public: false
      }
    },
    {
      path: "/edit-user-profile",
      name: "edit-user-profile",
      component: EditUserProfile,
      meta: {
        public: false
      }
    },
    {
      path: "/login",
      name: "login",
      meta: {
        layout: "auth"
      },
      component: Login
    },
    {
      path: "/register",
      name: "register",
      meta: {
        layout: "auth"
      },
      component: Register
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      meta: {
        layout: "auth"
      },
      component: ForgotPassword
    },
    {
      path: "/change-password/:token",
      name: "change-password",
      meta: {
        layout: "auth"
      },
      component: ChangePassword
    },
    {
      path: "/campaign/:id/companies",
      name: "campaign-companies",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: CampaignCompanies
    },

    {
      path: "/campaign/:id/prospects",
      name: "campaign-prospects",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: CampaignProspects
    },
    {
      path: "/campaign/:id/template-editor",
      name: "template-editor",
      meta: {
        layout: "icon-sidebar",
        public: false
      },
      component: TemplateEditor
    },
    {
      path: "/terms",
      name: "terms",
      meta: {
        layout: "docs",
        public: true
      },
      component: Terms
    },
    {
      path: "/privacy",
      name: "privacy",
      meta: {
        layout: "docs",
        public: true
      },
      component: Privacy
    },
    {
      path: "/pro-plan",
      name: "pro-plan",
      component: HasCard,
      meta: {
        public: true
      }
    },
    {
      path: "/billing",
      name: "billing",
      component: Billing,
      meta: {
        public: true
      }
    },
    {
      path: "/invoices",
      name: "invoices",
      component: Invoices,
      meta: {
        public: false
      }
    },
    {
      path: "/plan",
      name: "plan",
      component: Plan,
      meta: {
        public: true
      }
    },
    {
      path: "/errors",
      name: "errors",
      component: Errors
    },
    {
      path: "/linkedin",
      name: "linkedin-redirect",
      component: LinkedInOauthRedirect
    },
    {
      path: "/google",
      name: "google-redirect",
      component: GmailOauthRedirect
    },
    {
      path: "/other",
      name: "other-redirect",
      component: OtherOauthRedirect
    },
    {
      path: "/email-settings",
      name: "email-settings",
      meta: {
        layout: "auth",
        public: true
      },
      component: EmailSettings
    },
    {
      path: "/verify_email/:token",
      name: "verify-email",
      component: VerifyEmail
    },
    {
      path: "*",
      redirect: "/errors"
    }
  ]
});
